import { useEffect } from "react";
import { t } from "i18next";
import { Tag, Tooltip } from "antd";
import DataGrid from "../../core/components/data-grid/DataGrid";
import { useDataGrid } from "../../core/components/data-grid/DataGridContext";
import Helper from "../../core/Helper";
import ApiService from "../../core/service/ApiService";

export default function SmsLogDataGrid() {
    const { queryModel, setDataGridProps, setData, setPaginationResult } = useDataGrid();

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns: [
                {
                    dataIndex: 'createdDate', key: 'createdDate', title: t('Date'), sorter: true, width: 160,
                    render: (val) => Helper.Date.dateFormat(val)
                },
                { dataIndex: 'phoneNumber', key: 'phoneNumber', title: t('Phone'), width: 140, render: (val) => val || '-' },
                { dataIndex: 'user', key: 'user', title: t('User'), width: 160, render: (val) => val?.name || '-' },
                { dataIndex: 'type', key: 'type', title: t('Type'), width: 120, render: (val) => val || '-' },
                { dataIndex: 'service', key: 'service', title: t('Service'), width: 110, render: (val) => val || '-' },
                {
                    dataIndex: 'message', key: 'message', title: t('Message'),
                    render: (val) => <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{val}</span>
                },
                {
                    dataIndex: 'success', key: 'success', title: t('Status'), sorter: true, width: 100,
                    render: (val, row) => val
                        ? <Tag color="success">{t('Sent')}</Tag>
                        : <Tooltip title={row.error}><Tag color="error">{t('Failed')}</Tag></Tooltip>
                },
                {
                    dataIndex: 'error', key: 'error', title: t('Error'), width: 220,
                    render: (val) => val
                        ? <Tooltip title={val}><span style={{ color: '#cf1322' }}>{val}</span></Tooltip>
                        : '-'
                },
            ]
        })
    }, [])

    const load = async () => {
        const res = await ApiService.SmsLog.GetSmsLogDataGrid(queryModel);
        if (res.success) {
            setData(res.data)
            setPaginationResult(res.pagination);
        }
    }

    useEffect(() => {
        load()
    }, [queryModel.updateKey])

    return (
        <DataGrid />
    )
}
